import React, { useEffect, useState } from "react";

export const Header = (props) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Trigger animasi setelah mount
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300;700;900&display=swap');

        /* ===== INTRO SECTION ===== */
        .intro {
          display: flex;
          width: 100%;
          min-height: 100vh;
          background: url(../img/logo/bgcore.png) center center no-repeat;
          background-color: #1a1a2e;
          background-size: cover;
          position: relative;
          overflow: hidden;
        }

        /* Overlay gradient gelap */
        .intro .overlay {
          background: linear-gradient(
            135deg,
            rgba(0, 0, 0, 0.55) 0%,
            rgba(10, 20, 60, 0.45) 100%
          );
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          z-index: 2;
        }

        /* ===== PARTICLE LINES (CSS only) ===== */
        .intro::before {
          content: '';
          position: absolute;
          inset: 0;
          background-image:
            linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
          background-size: 60px 60px;
          z-index: 1;
          animation: gridDrift 20s linear infinite;
        }

        @keyframes gridDrift {
          0%   { transform: translateY(0); }
          100% { transform: translateY(60px); }
        }

        /* ===== GLOW ORBS ===== */
        .intro-orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(80px);
          z-index: 1;
          animation: orbFloat 8s ease-in-out infinite;
        }
        .intro-orb-1 {
          width: 500px; height: 500px;
          background: rgba(99, 130, 255, 0.18);
          top: -100px; left: -100px;
          animation-delay: 0s;
        }
        .intro-orb-2 {
          width: 400px; height: 400px;
          background: rgba(80, 200, 200, 0.12);
          bottom: -80px; right: -80px;
          animation-delay: 3s;
        }
        @keyframes orbFloat {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50%       { transform: translate(20px, -20px) scale(1.05); }
        }

        /* ===== INTRO TEXT CONTAINER ===== */
        .intro-text {
          text-align: center;
          padding: 20px 20px 20px 0;
          position: relative;
          z-index: 3;
        }

        /* ===== TAGLINE CHIP ===== */
        .intro-chip {
          display: inline-block;
          background: rgba(255,255,255,0.10);
          border: 1px solid rgba(255,255,255,0.25);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          color: rgba(255,255,255,0.85);
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 3px;
          text-transform: uppercase;
          padding: 8px 20px;
          border-radius: 100px;
          margin-bottom: 28px;

          opacity: 0;
          transform: translateY(20px);
          transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
        }
        .intro-loaded .intro-chip {
          opacity: 1;
          transform: translateY(0);
        }

        /* ===== HEADING ===== */
        .intro h1 {
          font-family: "Raleway", sans-serif;
          color: #fff;
          font-size: 82px;
          font-weight: 900;
          text-transform: uppercase;
          margin-top: 0;
          margin-bottom: 10px;
          line-height: 1.05;
          letter-spacing: -1px;
          text-shadow: 0 4px 40px rgba(0,0,0,0.3);

          opacity: 0;
          transform: translateY(40px);
          transition: opacity 0.8s cubic-bezier(0.22,1,0.36,1) 0.3s,
                      transform 0.8s cubic-bezier(0.22,1,0.36,1) 0.3s;
        }
        .intro-loaded h1 {
          opacity: 1;
          transform: translateY(0);
        }

        /* ===== DIVIDER LINE (under last word of title) ===== */
        .intro-title-last {
          display: block;
          position: relative;
          color: #ffffff !important;
        }
        .intro-title-last::after {
          content: '';
          display: block;
          height: 3px;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.9), rgba(255,255,255,0.9), transparent);
          border-radius: 2px;
          margin: 14px auto 0;
          width: 0;
          transition: width 0.9s cubic-bezier(0.22,1,0.36,1) 0.6s;
        }
        .intro-loaded .intro-title-last::after {
          width: 70%;
        }

        /* ===== PARAGRAPH ===== */
        .intro p {
          color: rgba(255,255,255,0.80);
          font-size: 20px;
          font-weight: 300;
          line-height: 32px;
          margin: 0 auto 40px;
          max-width: 560px;
          letter-spacing: 0.2px;

          opacity: 0;
          transform: translateY(30px);
          transition: opacity 0.8s ease 0.75s, transform 0.8s ease 0.75s;
        }
        .intro-loaded p {
          opacity: 1;
          transform: translateY(0);
        }

        /* ===== CTA BUTTON ===== */
        .btn-custom {
          display: inline-block;
          padding: 16px 44px;
          font-size: 14px;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: #fff !important;
          background: rgba(255,255,255,0.12);
          border: 1.5px solid rgba(255,255,255,0.45);
          border-radius: 100px;
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          text-decoration: none;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          transition: all 0.35s cubic-bezier(0.4,0,0.2,1);

          opacity: 0;
          transform: translateY(20px) scale(0.97);
        }
        .intro-loaded .btn-custom {
          opacity: 1;
          transform: translateY(0) scale(1);
          transition: opacity 0.7s ease 1s, transform 0.7s ease 1s,
                      background 0.35s ease, border-color 0.35s ease, box-shadow 0.35s ease;
        }
        .btn-custom::before {
          content: '';
          position: absolute;
          inset: 0;
          background: rgba(255,255,255,0);
          transition: background 0.3s ease;
        }
        .btn-custom:hover {
          background: rgba(255,255,255,0.22);
          border-color: rgba(255,255,255,0.75);
          box-shadow:
            0 0 30px rgba(255,255,255,0.15),
            0 8px 32px rgba(0,0,0,0.2);
          transform: translateY(-2px) scale(1.02);
          text-decoration: none;
        }
        .btn-custom:hover::before {
          background: rgba(255,255,255,0.05);
        }

        /* ===== SCROLL INDICATOR ===== */
        .scroll-indicator {
          position: absolute;
          bottom: 32px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 3;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          opacity: 0;
          transition: opacity 0.6s ease 1.4s;
        }
        .intro-loaded .scroll-indicator {
          opacity: 1;
        }
        .scroll-indicator span {
          font-size: 10px;
          letter-spacing: 3px;
          color: rgba(255,255,255,0.45);
          text-transform: uppercase;
        }
        .scroll-mouse {
          width: 22px;
          height: 34px;
          border: 1.5px solid rgba(255,255,255,0.35);
          border-radius: 12px;
          display: flex;
          justify-content: center;
          padding-top: 6px;
        }
        .scroll-mouse::before {
          content: '';
          width: 3px;
          height: 7px;
          background: rgba(255,255,255,0.6);
          border-radius: 2px;
          animation: scrollBounce 1.8s ease-in-out infinite;
        }
        @keyframes scrollBounce {
          0%, 100% { transform: translateY(0); opacity: 1; }
          70%       { transform: translateY(8px); opacity: 0; }
        }

        /* ===== RESPONSIVE ===== */

        /* Tablet landscape */
        @media (max-width: 1200px) {
          .intro h1 { font-size: 68px; }
        }

        /* Tablet portrait */
        @media (max-width: 992px) {
          .intro h1 { font-size: 52px; }
          .intro p   { font-size: 18px; max-width: 100%; }
          .intro-orb-1 { width: 300px; height: 300px; }
          .intro-orb-2 { width: 250px; height: 250px; }
          .intro-text { padding: 20px 16px 20px 0; }
        }

        /* Mobile — switch ke center agar tidak sempit di kiri */
        @media (max-width: 768px) {
          .intro .overlay { justify-content: center; }
          .intro-text {
            text-align: center;
            padding: 20px 16px;
          }
          .intro-divider { margin: 20px auto 24px; }
          .intro p {
            margin: 0 auto 32px;
            font-size: 17px;
            max-width: 480px;
          }
          .intro h1 {
            font-size: 44px;
            letter-spacing: 0px;
          }
        }

        /* Mobile small */
        @media (max-width: 640px) {
          .intro h1 {
            font-size: 34px;
            letter-spacing: 1px;
            margin-bottom: 16px;
          }
          .intro p {
            font-size: 15px;
            line-height: 26px;
            margin-bottom: 28px;
            padding: 0 4px;
          }
          .intro-text { padding: 0 16px; }
          .btn-custom { padding: 12px 28px !important; font-size: 13px !important; }
          .intro-orb-1 { width: 200px; height: 200px; }
          .intro-orb-2 { width: 180px; height: 180px; }
        }

        /* Mobile XS */
        @media (max-width: 400px) {
          .intro h1 { font-size: 28px; }
          .intro p { font-size: 14px; line-height: 22px; }
          .btn-custom { padding: 10px 22px !important; font-size: 12px !important; }
        }
      `}</style>

      <header id="header">
        <div className={`intro ${loaded ? "intro-loaded" : ""}`}>

          {/* Glow orbs */}
          <div className="intro-orb intro-orb-1" />
          <div className="intro-orb intro-orb-2" />

          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="col-md-8 mx-auto intro-text">

                  {/* Chip tagline */}
                  

                  <h1>
                    {props.data ? (
                      <>
                        {props.data.title.split(" ").slice(0, -1).join(" ")}{" "}
                        <span className="intro-title-last">
                          {props.data.title.split(" ").slice(-1)[0]}
                        </span>
                      </>
                    ) : "Loading"}
                  </h1>

                  {/* Spacing after divider */}
                  <div style={{ marginBottom: "24px" }} />

                  <p>{props.data ? props.data.paragraph : "Loading"}</p>

                  <a href="#about" className="btn btn-custom btn-lg page-scroll">
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Scroll indicator */}

        </div>
      </header>
    </>
  );
};